<script setup lang="ts">
import { computed } from 'vue'

import { marketSocket } from '@/services/marketSocket'

const label = computed(() => {
  const labels = {
    idle: '行情待連線',
    connecting: '行情連線中',
    connected: '即時行情',
    reconnecting: '行情重新連線中',
    disconnected: '定時更新',
  }
  return labels[marketSocket.status.value]
})
</script>

<template>
  <span class="connection-badge" :data-status="marketSocket.status.value">
    <i aria-hidden="true"></i>{{ label }}
  </span>
</template>
